import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";

import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import AdminLayout from "./components/AdminLayout";

import AdminDashboard from "./pages/AdminDashboard";
import UsersPage from "./pages/UsersPage";
import MinigamesPage from "./pages/MinigamesPage";
import SeasonsPage from "./pages/SeasonsPage";
import MissionsPage from "./pages/MissionsPage";
import StorePage from "./pages/StorePage";
import LocalizationPage from "./pages/LocalizationPage";
import StorageExplorerPage from "./pages/StorageExplorerPage";
import ToolsPage from "./pages/ToolsPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin" replace />} />

      <Route path="/login" element={<Login />} />

      {/* Ruta pública para solicitar eliminación de cuenta */}
      <Route path="/delete-account" element={<DeleteAccountPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />}/>
      <Route path="/delete-account" element={<DeleteAccountPage />}/>

      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="minigames" element={<MinigamesPage />} />
        <Route path="seasons" element={<SeasonsPage />} />
        <Route path="missions" element={<MissionsPage />} />
        <Route path="store" element={<StorePage />} />
        <Route path="localization" element={<LocalizationPage />} />
        <Route path="storage" element={<StorageExplorerPage />} />
        <Route path="tools" element={<ToolsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}

export default App;